import { Loader } from "@googlemaps/js-api-loader"
import MarkerClusterer from '@googlemaps/markerclustererplus';
import gsap from 'gsap';
import $ from 'jquery';

const googleMaps              = {
	settings: {
		apiKey: compensa_general.google_api_key,
		mapCenter: {
			center: {
				lat: 52.409538,
				lng: 16.931992,
			},
			zoom: 6
		},
		filteredValues: [],
		filtersProperty: null,
		markers: null,
		activeMarkerIndex: null,
		locations: [],
		zoomLevel: Number,
		markerClusterer: null,
		map: null,
		searchInput: null,
		animationElements: Object,
		animationProperty: Object,
		clickedAnimation: false,
		lastClickedMarkerIcon: null,
		mapType : null,
		searchCoords: {
			lat: Number,
			lng: Number
		}
	},

	// Keyboard navigation helpers for markers
	focusNextMarker() {
		if (!this.markers || !this.markers.length) return;
		let idx = (this.activeMarkerIndex === null || this.activeMarkerIndex === undefined) ? -1 : parseInt(this.activeMarkerIndex, 10);
		idx = (idx + 1) % this.markers.length;
		this.activateMarkerByArrayIndex(idx);
	},
	focusPrevMarker() {
		if (!this.markers || !this.markers.length) return;
		let len = this.markers.length;
		let idx = (this.activeMarkerIndex === null || this.activeMarkerIndex === undefined) ? 0 : parseInt(this.activeMarkerIndex, 10);
		idx = (idx - 1 + len) % len;
		this.activateMarkerByArrayIndex(idx);
	},
	activateMarkerByArrayIndex( idx ) {
		if (!this.markers || !this.markers.length) return;
		const i = parseInt(idx, 10);
		if (isNaN(i) || i < 0 || i >= this.markers.length) return;
		const marker = this.markers[i];
		if (!marker) return;
		this.activeMarkerIndex = i;
		this.clickMarker(marker);
		this.announceActiveMarker(marker);
	},
	announceActiveMarker( marker ) {
		if (!marker || !this.markers) return;
		if (!this.liveElement) return;
		const name = marker.data && marker.data.address && marker.data.address.name ? marker.data.address.name : '';
		const city = marker.data && marker.data.address && marker.data.address.city ? marker.data.address.city : '';
		this.liveElement.textContent = `${name} ${city}`.trim();
	},

	init: function() {
		const checkPage = document.querySelector( '.map' );
		if (checkPage == null) {
			return;
		}

		this.zoomLevel = 6;
		this.setFiltersStyle.call( this );
		this.initPrepareElements();
		this.initGoogleMaps.call( this );

	},
	initPrepareElements() {
		const searchButton    = document.querySelector( '#map_search' );
		const getLocalization = document.querySelector( '#get_localization' );
		const backList        = document.querySelector( '#backToList' );

		this.backList = backList;
		const mobileMapButton = document.querySelector( '.map__wrapper__tabs__map' );
		const mobileMapList   = document.querySelector( '.map__wrapper__tabs__list' );

		this.filtersProperty  = document.querySelectorAll( '.map__wrapper__navigation__filters__input input' );
		this.searchInput      = document.querySelector( '.map__wrapper__navigation__find__input input' );
		this.settings.mapType = document.querySelector( '#map' ).dataset.type;

		if(this.settings.mapType === 'partners') {
			document.querySelector( '.map__wrapper__navigation__filters' ).style.display = 'none';
		}
		this.isMobile = window.matchMedia( '(max-width: 768px)' ).matches;

		this.animationElements = {
			navigator: document.querySelector( '.map__wrapper__navigation' ),
			filters: document.querySelector( '.map__wrapper__navigation__filters' ),
			list: document.querySelector( '.map__wrapper__navigation__list' ),
			find: document.querySelector( '.map__wrapper__navigation__find' ),
			specific: document.querySelector( '.map__wrapper__navigation__specific' ),
			tabs: document.querySelector( '.map__wrapper__tabs' ),
			map: document.querySelector( '#map' ),
		}

		this.animationProperty = {
			navigatorHeight: this.animationElements.navigator.offsetHeight,
			filtersHeight: this.animationElements.filters.offsetHeight,
			listHeight: this.animationElements.list.offsetHeight,
			listMarginTop: parseFloat( window.getComputedStyle( this.animationElements.list ).marginTop ),
			specificHeight: this.animationElements.specific.offsetHeight,
			mapHeight: this.animationElements.map.offsetHeight
		}

		window.addEventListener( 'resize', this.handleResize.bind( this ) )
		searchButton.addEventListener( 'click', this.getGeolocalizationRemote.bind( this ) )
		getLocalization.addEventListener( 'click', this.getGeolocalizationLocal.bind( this ) )
		mobileMapButton.addEventListener( 'click', this.switchMapDisplay.bind( this ) )
		mobileMapList.addEventListener( 'click', this.switchMapDisplay.bind( this ) )
		backList.addEventListener( 'click', this.backToList.bind( this ) )

		// make #backToList reachable by keyboard and activatable with Enter/Space
		if (backList) {
			if (!backList.hasAttribute('tabindex')) {
				backList.setAttribute('tabindex', '0');
			}
			if (!backList.hasAttribute('role')) {
				backList.setAttribute('role', 'button');
			}
			backList.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					backList.click();
				}
			});
		}

			// Add a skip-link before the map to jump back to the search input (markup may already exist in templates)
			try {
				if (document.querySelector('#map') && !document.querySelector('.skip-to-search-map')) {
					const skip = document.createElement('a');
					skip.href = '#autoComplete';
					skip.className = 'skip-to-search-map sr-only';
					skip.textContent = 'Przejdź do wyszukiwarki';
					const mapEl = document.querySelector('#map');
					mapEl.parentNode.insertBefore(skip, mapEl);
				}
			} catch (err) {
				// non-fatal
			}
		this.filtersProperty.forEach( el => el.addEventListener( 'change', this.selectedFilters.bind( this ) ) )
	},
	setFiltersStyle() {
		const filtersChildren = document.querySelector( '.map__wrapper__navigation__filters' ).children;
		const baseOffsetTop   = filtersChildren[0].offsetTop;

		[...filtersChildren].forEach(
			el => {
				el.removeAttribute( 'style' );
				if (el.offsetTop > baseOffsetTop) {
					el.style.marginTop = '15px';
				}
			}
		)
	},
	initGoogleMaps() {
		const googleMapsContainer = document.querySelector( '#map' );

		const loader = new Loader(
			{
				apiKey: this.settings.apiKey,
				libraries: ["places"]
			}
		);

		loader
			.load()
			.then(
				() => {
					if (this.isMobile) {
						this.settings.mapCenter = {
							center: {
								lat: 51.7730343,
								lng: 19.3401663,
							},
							zoom: 5.5
						}
					}
					this.map = new google.maps.Map( googleMapsContainer, this.settings.mapCenter );
					this.map.addListener( 'idle', this.observeZoomLevel.bind( this ) )

					// make map container focusable and add keyboard navigation for markers
					try {
						if (googleMapsContainer && !googleMapsContainer.hasAttribute('tabindex')) {
							googleMapsContainer.setAttribute('tabindex', '0');
						}
						if (googleMapsContainer && !googleMapsContainer.hasAttribute('role')) {
							googleMapsContainer.setAttribute('role', 'region');
							googleMapsContainer.setAttribute('aria-label', 'Mapa — nawigacja punktów');
						}
						// create an aria-live element for announcements
						if (!this.liveElement) {
							this.liveElement = document.createElement('div');
							this.liveElement.setAttribute('aria-live', 'polite');
							this.liveElement.style.position = 'absolute';
							this.liveElement.style.left = '-9999px';
							document.body.appendChild(this.liveElement);
						}

						googleMapsContainer.addEventListener('keydown', (e) => {
							// Backspace should activate backToList unless user is editing a field
							if (e.key === 'Backspace') {
								const activeEl = document.activeElement;
								if (activeEl && (activeEl.tagName === 'INPUT' || activeEl.tagName === 'TEXTAREA' || activeEl.isContentEditable)) {
									// allow normal editing
									return;
								}
								const back = this.backList || document.querySelector('#backToList');
								if (back) {
									e.preventDefault();
									back.click();
								}
								return;
							}
							// (No Tab lock here — allow normal Tab behavior to move out of the map)
							// Only handle navigation when the map container itself has focus
							const targetIsMap = (document.activeElement === googleMapsContainer);
							// Arrow navigation — next/previous marker
							if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
								e.preventDefault();
								this.focusNextMarker();
								return;
							}
							if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
								e.preventDefault();
								this.focusPrevMarker();
								return;
							}
							if (e.key === 'Home') {
								e.preventDefault();
								this.activateMarkerByArrayIndex(0);
								return;
							}
							if (e.key === 'End') {
								e.preventDefault();
								if (this.markers && this.markers.length) {
									this.activateMarkerByArrayIndex(this.markers.length - 1);
								}
								return;
							}
							// Enter/Space: if the map itself is focused, activate the currently indexed marker
							if (e.key === 'Enter' || e.key === ' ') {
								if (targetIsMap) {
									e.preventDefault();
									if (this.activeMarkerIndex !== null && this.activeMarkerIndex !== undefined) {
										this.activateMarkerByArrayIndex(this.activeMarkerIndex);
									} else {
										// fallback: try to activate a focused child element
										const active = document.activeElement;
										if (active && active !== googleMapsContainer && googleMapsContainer.contains(active)) {
											if (typeof active.click === 'function') active.click();
										}
									}
								}
							}
						});
					} catch (err) {
						// non-fatal
					}

					const input    = document.getElementById( "autoComplete" );
					const options      = {
						componentRestrictions: { country: "pl" },
						fields: ["address_components", "geometry"],
					};
					this.getEnterPartners();
					const autocomplete = new google.maps.places.Autocomplete( input, options );
					autocomplete.addListener(
						'place_changed',
						function() {

							const place = autocomplete.getPlace();

							this.settings.searchCoords['lat'] = place.geometry.location.lat();
							this.settings.searchCoords['lng'] = place.geometry.location.lng();

							this.zoomMapAfterClick();

						}.bind( this )
					);
				}
			)
			.catch( error => console.error( error ) )
	},
	setClusterMarkers( locations ) {

		this.markers = locations.map(
			function(location, i) {
				let categoryIcon;
				if (location[3].includes( "agent" )) {
					categoryIcon = "data:image/svg+xml;base64,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";
				} else if (location[3].includes( "place" )) {
					categoryIcon = "data:image/svg+xml;base64,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"
				} else if (location[3].includes( "partner" )) {
					categoryIcon = "data:image/svg+xml;base64,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"
				}  else {
					categoryIcon = '';
				}

				return new google.maps.Marker(
					{
						index: location[0],
						position: new google.maps.LatLng( parseFloat( location[1] ),parseFloat( location[2] ) ),
						category: location[3],
						data: location[4],
						icon: categoryIcon
					}
				);
			}
		);

		this.markers.forEach( el => google.maps.event.addListener( el, 'click', () => this.clickMarker( el ) ) )


		this.markerClusterer = new MarkerClusterer(
			this.map,
			this.markers,
			{
				styles:  [
					{
						width: 39,
						height: 39,
						className: "custom-clustericon-1",
					}
				],
				clusterClass: "custom-clustericon"
			}
		);


	},
	clickMarker( el ) {
		if (this.clickedMarkerIndex == el.index) {
			return
		} else {
			this.clearSpecificContent();
		}

		this.clickedMarkerIndex = el.index;
		const latMarker         = el.position.lat();
		const lngMarker         = el.position.lng();
		const pos               = new google.maps.LatLng( latMarker,lngMarker );

		const duplicateMarkers = this.checkDuplicatePosition( el );

		this.zoomLevel             = 18;
		this.clickedAnimation      = true;
		this.lastClickedMarkerIcon = el;
		this.setNavigationContent( duplicateMarkers )
		this.setClickedMarkerIcon();

		this.map.setCenter( pos );
		this.map.setZoom( this.zoomLevel );
	},
	setClickedMarkerIcon() {
		if (this.lastClickedMarkerIcon.category.includes('agent')) {
			this.lastClickedMarkerIcon.setIcon( 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA0NCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0yMS45OTkgMUMxNi40MzE0IDEuMDA2MzUgMTEuMDkzNyAzLjIyMDg5IDcuMTU2NzYgNy4xNTc3N0MzLjIxOTg4IDExLjA5NDcgMS4wMDUzNCAxNi40MzI0IDAuOTk4OTkxIDIyQzAuOTg1NTUyIDI0Ljk1NjQgMS42MTIyNCAyNy44ODA3IDIuODM1OTkgMzAuNTcyQzguMDg2OTkgNDIuMDYxIDE4LjE1MyA1NC4xOTEgMjEuMTE3IDU3LjYzNUMyMS4yMjY3IDU3Ljc2MjMgMjEuMzYyNiA1Ny44NjQ1IDIxLjUxNTUgNTcuOTM0NUMyMS42NjgzIDU4LjAwNDYgMjEuODM0NCA1OC4wNDA4IDIyLjAwMjUgNTguMDQwOEMyMi4xNzA2IDU4LjA0MDggMjIuMzM2NyA1OC4wMDQ2IDIyLjQ4OTUgNTcuOTM0NUMyMi42NDIzIDU3Ljg2NDUgMjIuNzc4MiA1Ny43NjIzIDIyLjg4OCA1Ny42MzVDMjUuODQ4IDU0LjE5MiAzNS45MTQgNDIuMDYzIDQxLjE2NiAzMC41NzJDNDIuMzg5IDI3Ljg4MDYgNDMuMDE0NyAyNC45NTYyIDQzIDIyQzQyLjk5MzEgMTYuNDMyNCA0MC43NzgzIDExLjA5NDggMzYuODQxMyA3LjE1OEMzMi45MDQzIDMuMjIxMiAyNy41NjY2IDEuMDA2NjIgMjEuOTk5IDFWMVoiIGZpbGw9IndoaXRlIiBzdHJva2U9IiMwMDc4MzEiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMjIuMzU2MyAxNy45NzAxQzIzLjg2MzQgMTcuOTcwMSAyNS4xNjgyIDE3LjQyOTUgMjYuMjM0NyAxNi4zNjMxQzI3LjMwMDggMTUuMjk2OCAyNy44NDE1IDEzLjk5MjEgMjcuODQxNSAxMi40ODQ5QzI3Ljg0MTUgMTAuOTc4MSAyNy4zMDEgOS42NzMyOCAyNi4yMzQ1IDguNjA2NjRDMjUuMTY4MSA3LjU0MDUzIDIzLjg2MzIgNyAyMi4zNTYzIDdDMjAuODQ5IDcgMTkuNTQ0NCA3LjU0MDUzIDE4LjQ3ODEgOC42MDY4MkMxNy40MTE4IDkuNjczMTEgMTYuODcxMSAxMC45NzggMTYuODcxMSAxMi40ODQ5QzE2Ljg3MTEgMTMuOTkyMSAxNy40MTE4IDE1LjI5NyAxOC40NzgxIDE2LjM2MzNDMTkuNTQ0NyAxNy40Mjk0IDIwLjg0OTYgMTcuOTcwMSAyMi4zNTYzIDE3Ljk3MDFWMTcuOTcwMVpNMTkuNDIxOSA5LjU1MDQ0QzIwLjI0MDEgOC43MzIyNiAyMS4xOTk4IDguMzM0NTYgMjIuMzU2MyA4LjMzNDU2QzIzLjUxMjYgOC4zMzQ1NiAyNC40NzI2IDguNzMyMjYgMjUuMjkwOSA5LjU1MDQ0QzI2LjEwOTEgMTAuMzY4OCAyNi41MDcgMTEuMzI4NyAyNi41MDcgMTIuNDg0OUMyNi41MDcgMTMuNjQxMyAyNi4xMDkxIDE0LjYwMTEgMjUuMjkwOSAxNS40MTk1QzI0LjQ3MjYgMTYuMjM3OCAyMy41MTI2IDE2LjYzNTUgMjIuMzU2MyAxNi42MzU1QzIxLjIwMDIgMTYuNjM1NSAyMC4yNDA0IDE2LjIzNzYgMTkuNDIxOSAxNS40MTk1QzE4LjYwMzUgMTQuNjAxMyAxOC4yMDU2IDEzLjY0MTMgMTguMjA1NiAxMi40ODQ5QzE4LjIwNTYgMTEuMzI4NyAxOC42MDM1IDEwLjM2ODggMTkuNDIxOSA5LjU1MDQ0WiIgZmlsbD0iIzAwNzgzMSIvPgo8cGF0aCBkPSJNMzEuOTU0IDI0LjUxMTdDMzEuOTIzMiAyNC4wNjc5IDMxLjg2MSAyMy41ODM5IDMxLjc2OTQgMjMuMDcyN0MzMS42NzcgMjIuNTU3NyAzMS41NTggMjIuMDcwOSAzMS40MTU1IDIxLjYyNTlDMzEuMjY4MiAyMS4xNjYgMzEuMDY4MiAyMC43MTE4IDMwLjgyMDYgMjAuMjc2NkMzMC41NjQgMTkuODI0OCAzMC4yNjIzIDE5LjQzMTUgMjkuOTIzOSAxOS4xMDc4QzI5LjU3IDE4Ljc2OTEgMjkuMTM2NiAxOC40OTY5IDI4LjYzNTYgMTguMjk4M0MyOC4xMzYyIDE4LjEwMDcgMjcuNTgyOCAxOC4wMDA3IDI2Ljk5MDkgMTguMDAwN0MyNi43NTg0IDE4LjAwMDcgMjYuNTMzNiAxOC4wOTYgMjYuMDk5NCAxOC4zNzg3QzI1LjgzMjEgMTguNTUzIDI1LjUxOTYgMTguNzU0NiAyNS4xNzA3IDE4Ljk3NzVDMjQuODcyNCAxOS4xNjc2IDI0LjQ2ODIgMTkuMzQ1NiAyMy45NjkgMTkuNTA2OUMyMy40ODIgMTkuNjY0NSAyMi45ODc1IDE5Ljc0NDQgMjIuNDk5MyAxOS43NDQ0QzIyLjAxMTQgMTkuNzQ0NCAyMS41MTY5IDE5LjY2NDUgMjEuMDI5NiAxOS41MDY5QzIwLjUzMDkgMTkuMzQ1OCAyMC4xMjY2IDE5LjE2NzcgMTkuODI4OCAxOC45Nzc2QzE5LjQ4MzIgMTguNzU2OCAxOS4xNzA1IDE4LjU1NTMgMTguODk5MyAxOC4zNzg2QzE4LjQ2NTQgMTguMDk1OSAxOC4yNDA2IDE4LjAwMDUgMTguMDA4MSAxOC4wMDA1QzE3LjQxNiAxOC4wMDA1IDE2Ljg2MjggMTguMTAwNyAxNi4zNjM2IDE4LjI5ODVDMTUuODYyOCAxOC40OTY3IDE1LjQyOTMgMTguNzY5IDE1LjA3NTEgMTkuMTA4QzE0LjczNjYgMTkuNDMxOCAxNC40MzUgMTkuODI1IDE0LjE3ODUgMjAuMjc2NkMxMy45MzEzIDIwLjcxMTggMTMuNzMxMSAyMS4xNjU4IDEzLjU4MzggMjEuNjI2MUMxMy40NDE1IDIyLjA3MSAxMy4zMjI1IDIyLjU1NzcgMTMuMjMgMjMuMDcyN0MxMy4xMzgzIDIzLjU4MzIgMTMuMDc2MyAyNC4wNjc0IDEzLjA0NTUgMjQuNTEyMkMxMy4wMTUzIDI0Ljk0NzEgMTMgMjUuMzk5NyAxMyAyNS44NTdDMTMgMjcuMDQ1OCAxMy4zNzc5IDI4LjAwODIgMTQuMTIzMSAyOC43MTc5QzE0Ljg1OTEgMjkuNDE4MyAxNS44MzI4IDI5Ljc3MzUgMTcuMDE3MiAyOS43NzM1SDI3Ljk4MjhDMjkuMTY2OSAyOS43NzM1IDMwLjE0MDYgMjkuNDE4MyAzMC44NzY3IDI4LjcxNzlDMzEuNjIyMSAyOC4wMDg3IDMyIDI3LjA0NiAzMiAyNS44NTY4QzMxLjk5OTggMjUuMzk4IDMxLjk4NDQgMjQuOTQ1NCAzMS45NTQgMjQuNTExN1YyNC41MTE3Wk0yOS45NTY2IDI3Ljc1MUMyOS40NzAyIDI4LjIxMzkgMjguODI0NiAyOC40Mzg5IDI3Ljk4MjYgMjguNDM4OUgxNy4wMTcyQzE2LjE3NTEgMjguNDM4OSAxNS41Mjk0IDI4LjIxMzkgMTUuMDQzMyAyNy43NTEyQzE0LjU2NjMgMjcuMjk3MiAxNC4zMzQ2IDI2LjY3NzQgMTQuMzM0NiAyNS44NTdDMTQuMzM0NiAyNS40MzAzIDE0LjM0ODYgMjUuMDA4OSAxNC4zNzY4IDI0LjYwNDVDMTQuNDA0MiAyNC4yMDc2IDE0LjQ2MDMgMjMuNzcxNyAxNC41NDM2IDIzLjMwODVDMTQuNjI1OCAyMi44NTEgMTQuNzMwNCAyMi40MjE3IDE0Ljg1NDggMjIuMDMzQzE0Ljk3NDEgMjEuNjYwMyAxNS4xMzY5IDIxLjI5MTMgMTUuMzM4OCAyMC45MzU4QzE1LjUzMTUgMjAuNTk3IDE1Ljc1MzIgMjAuMzA2MyAxNS45OTc4IDIwLjA3MjFDMTYuMjI2NyAxOS44NTMgMTYuNTE1MSAxOS42NzM3IDE2Ljg1NDkgMTkuNTM5MkMxNy4xNjkyIDE5LjQxNDggMTcuNTIyNSAxOS4zNDY3IDE3LjkwNTkgMTkuMzM2NEMxNy45NTI3IDE5LjM2MTMgMTguMDM1OSAxOS40MDg3IDE4LjE3MDcgMTkuNDk2NkMxOC40NDUxIDE5LjY3NTQgMTguNzYxMyAxOS44Nzk0IDE5LjExMDkgMjAuMTAyN0MxOS41MDQ5IDIwLjM1MzkgMjAuMDEyNiAyMC41ODA4IDIwLjYxOTIgMjAuNzc2NkMyMS4yMzkzIDIwLjk3NzEgMjEuODcxNyAyMS4wNzg5IDIyLjQ5OTUgMjEuMDc4OUMyMy4xMjcyIDIxLjA3ODkgMjMuNzU5OCAyMC45NzcxIDI0LjM3OTYgMjAuNzc2OEMyNC45ODY3IDIwLjU4MDYgMjUuNDk0MiAyMC4zNTM5IDI1Ljg4ODggMjAuMTAyM0MyNi4yNDY1IDE5Ljg3MzcgMjYuNTUzOSAxOS42NzU2IDI2LjgyODIgMTkuNDk2NkMyNi45NjMxIDE5LjQwODkgMjcuMDQ2MyAxOS4zNjEzIDI3LjA5MyAxOS4zMzY0QzI3LjQ3NjcgMTkuMzQ2NyAyNy44Mjk5IDE5LjQxNDggMjguMTQ0NCAxOS41MzkyQzI4LjQ4NCAxOS42NzM3IDI4Ljc3MjUgMTkuODUzMiAyOS4wMDEzIDIwLjA3MjFDMjkuMjQ1OSAyMC4zMDYxIDI5LjQ2NzYgMjAuNTk2OCAyOS42NjAzIDIwLjkzNkMyOS44NjI0IDIxLjI5MTMgMzAuMDI1NCAyMS42NjA1IDMwLjE0NDUgMjIuMDMyOEMzMC4yNjkxIDIyLjQyMiAzMC4zNzM5IDIyLjg1MTIgMzAuNDU1OSAyMy4zMDgzQzMwLjUzOSAyMy43NzI0IDMwLjU5NTIgMjQuMjA4NSAzMC42MjI3IDI0LjYwNDZWMjQuNjA1QzMwLjY1MSAyNS4wMDc5IDMwLjY2NTMgMjUuNDI5MSAzMC42NjU0IDI1Ljg1N0MzMC42NjUzIDI2LjY3NzYgMzAuNDMzNSAyNy4yOTcyIDI5Ljk1NjYgMjcuNzUxVjI3Ljc1MVoiIGZpbGw9IiMwMDc4MzEiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSI0NCIgaGVpZ2h0PSI1OS4wNCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K' )
		} else if (this.lastClickedMarkerIcon.category.includes('partner')) {
			this.lastClickedMarkerIcon.setIcon('data:image/svg+xml;base64,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');
		} else {
			this.lastClickedMarkerIcon.setIcon( 'data:image/svg+xml;base64,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' )
		}
	},
	unsetClickedMarkerIcon() {
		if (this.lastClickedMarkerIcon.category.includes('agent')) {
			this.lastClickedMarkerIcon.setIcon( 'data:image/svg+xml;base64,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' )
		} else if (this.lastClickedMarkerIcon.category.includes('partner')) {
			this.lastClickedMarkerIcon.setIcon('data:image/svg+xml;base64,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');
		} else {
			this.lastClickedMarkerIcon.setIcon( 'data:image/svg+xml;base64,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' )
		}
	},
	clearSpecificContent() {
		[...this.animationElements.specific.children].forEach(
			(el, index) => {
				if (index != 0 ) {
					el.remove();
				}
			}
		)
	},
	checkDuplicatePosition( el ) {
		const latMarker = el.position.lat();
		const lngMarker = el.position.lng();

		const duplicateMarkers = this.markers.filter(
			el => {
				const elLat        = el.position.lat();
				const elLng        = el.position.lng();
				return elLat == latMarker && elLng == lngMarker
			}
		)

		return duplicateMarkers
	},
	observeZoomLevel() {
		this.zoomLevel = this.map.getZoom();
		this.changeClusterMarkers( this.markers );
		this.navigatorBehaviour();
		setTimeout( () => this.getMarkersInViewport(), 100 )
		this.selectedFilters()
	},
	zoomMap() {
		let geolocation = new google.maps.LatLng( parseFloat( this.settings.searchCoords.lat ),parseFloat( this.settings.searchCoords.lng ) );
		this.zoomLevel = 11;
		this.map.setCenter( geolocation );
		this.map.setZoom( this.zoomLevel );
	},
	zoomMapAfterClick() {
		this.zoomMap()
		let geocoder = new google.maps.Geocoder();
		const latlng = {
			lat: parseFloat(this.settings.searchCoords['lat']),
			lng: parseFloat(this.settings.searchCoords['lng']),
		};

		geocoder.geocode( { location: latlng }, (results, status) => {
			if (status == 'OK') {
				this.getLocations( results[0].formatted_address );
			} else {
				alert('Geocode was not successful for the following reason: ' + status);
			}
		});

	},
	async getGeolocalizationRemote() {
		const searchValue = this.searchInput.value;

		if( searchValue.length === 0 ) return;
		try {
			const response      = await fetch( `https://nominatim.openstreetmap.org?q=${searchValue}&format=json&limit=1` )
			const data          = await response.json();
			this.settings.searchCoords['lat'] = parseFloat( data[0].lat );
			this.settings.searchCoords['lng'] = parseFloat( data[0].lon );

			this.getLocations( searchValue );

		} catch (error) {
			console.error( error )
		}

		this.zoomMapAfterClick();
	},
	getGeolocalizationLocal() {
		const input    = document.getElementById( "autoComplete" )
		let geocoder = new google.maps.Geocoder();
		let latlng = {
			lat : '',
			lng : ''
		}

		navigator.geolocation.getCurrentPosition(
			(position) => {
				this.settings.searchCoords['lat'] = position.coords.latitude;
				this.settings.searchCoords['lng'] = position.coords.longitude;
				latlng = {
					lat: parseFloat( this.settings.searchCoords['lat'] ),
					lng: parseFloat( this.settings.searchCoords['lng'] ),
				};
				geocoder.geocode( { location: latlng }, (results, status) => {
					if (status == 'OK') {
						input.value = results[0].formatted_address;
						this.zoomMap();
						this.getLocations( input.value );
					} else {
						alert('Geocode was not successful for the following reason: ' + status);
					}
				});
			}
		)


	},
	changeClusterMarkers( markers ) {

		if (this.zoomLevel < 12) {
			if (this.whichMarkers == "circle") {
				return;
			}

			this.whichMarkers = "circle";

			if (this.markerClusterer) {
				this.markerClusterer.clearMarkers()
			}


			this.markerClusterer = new MarkerClusterer(
				this.map,
				markers,
				{
					maxZoom: 16,
					styles:  [
						{
							width: 39,
							height: 39,
							className: "custom-clustericon-1",
						}
					],
					clusterClass: "custom-clustericon",
					zoomOnClick: false
				}
			);

			google.maps.event.addListener(
				this.markerClusterer,
				'clusterclick',
				function(cluster){
					this.map.setCenter( cluster.getCenter() );
					this.map.setZoom( 12 );
				}
			);

		} else if (this.zoomLevel >= 12) {
			if (this.whichMarkers == "pin") {
				return;
			}

			this.whichMarkers = "pin";
			this.markerClusterer.clearMarkers();


			this.markerClusterer = new MarkerClusterer(
				this.map,
				markers,
				{
					maxZoom: 16,
					styles: [
						{
							anchorText: [9, 0],
							height: 58,
							textColor: '#ffffff',
							url: "/app/themes/osom-theme/src/img//placeholder_1.png",
							width: 42,
							textSize: 16,
							textLineHeight: 24,
							fontWeight: "700"
						}
					]
				}
			);
		}
	},
	getMarkersInViewport() {
		let visibleMarkers = [];
		let bounds         = this.map.getBounds();

		if (this.markers !== undefined) {
			this.markers.filter( m => m.isAdded ).forEach(
				m => {
					if (bounds.contains( m.getPosition() )) {
						const markerObject = {
							index: m.index,
							data: m.data,
							category: m.category,
							coords: {
								lat: m.getPosition().lat(),
								lng: m.getPosition().lng()
							}
						}
						visibleMarkers.push( markerObject )
					}
				}
			)
		}

		if (visibleMarkers.length != 0) {
			this.getDistance(visibleMarkers);
		}
	},
	getDistance(points) {
		points.forEach(el => {
			const lat1 = this.settings.searchCoords.lat,
				lon1 = this.settings.searchCoords.lng,
				lat2 = el.coords.lat,
				lon2 = el.coords.lng

			const deg2rad = deg => (deg * Math.PI) / 180.0;
			const rad2deg = rad => (rad * 180.0) / Math.PI;

			const theta = lon1 - lon2;
			let dist = Math.sin( deg2rad( lat1 ) ) * Math.sin( deg2rad( lat2 ) ) + Math.cos( deg2rad( lat1 ) ) * Math.cos( deg2rad( lat2 ) ) * Math.cos( deg2rad( theta ) )
			dist = Math.acos( dist );
			dist = rad2deg( dist );
			const distance = Math.round(dist * 60 * 1.1515 * 1.609344);

			el['distance'] = distance;
		})

		this.sortByDistance(points);

	},
	sortByDistance(points) {
		points.sort(function(a,b) {
			return a.distance - b.distance;
		});

		this.setList(points);
	},
	selectedFilters() {
		if(document.body.classList.contains('page-template-page-search-partners')) return;

		this.filteredValues =
			Array.from( this.filtersProperty )
				.filter( i => i.checked )
				.map( i => i.value )

		this.showFilteredMarkers();
	},
	showFilteredMarkers() {
		let filteredMarkers = []

		this.whichMarkers = null

		if(!this.filteredValues.includes( 'live' ) && !this.filteredValues.includes( 'property' )) {
			this.markerClusterer.clearMarkers();
		} else {
			if(this.markers) {
				this.markers.forEach(el => {
					const exist = this.filteredValues.filter(val => el.category.includes(val))

					if(exist.length >= 2 || exist.includes('place')) {
						filteredMarkers.push(el);
					}
				})

				this.changeClusterMarkers(filteredMarkers)
			}
		}
	},
	switchMapDisplay( e ) {
		this.mobileNavigatorDisplay = e.target.innerText.toLowerCase();

		if (this.mobileNavigatorDisplay == "lista") {
			this.animationElements.tabs.classList.add( 'var_list' );

			gsap.timeline()
				.to( this.animationElements.map, {duration: 0.3, opacity: 0, visibility: 'hidden', position: 'absolute', width: '100%'} )
				.to( this.animationElements.navigator, {duration: 0.3, height: this.animationProperty.navigatorHeight + this.animationProperty.listHeight + this.animationProperty.listMarginTop + this.animationProperty.filtersHeight + 20 + 'px'}, '-=0.3' )
				.to( [this.animationElements.filters, this.animationElements.list], {duration: 0.3, opacity: 1, visibility: 'visible', position: 'relative'} )

		} else if (this.mobileNavigatorDisplay == "mapa") {
			this.animationElements.tabs.classList.remove( 'var_list' );

			gsap.timeline()
				.to( this.animationElements.navigator, {duration: 0.3, height: this.animationProperty.navigatorHeight + this.animationProperty.filtersHeight + 'px'} )
				.to( this.animationElements.list, {duration: 0.3, opacity: 0, visibility: 'hidden', position: 'absolute'}, '-=0.3' )
				.to( this.animationElements.map, {duration: 0.3, opacity: 1, visibility: 'visible', position: 'relative'}, '-=0.3' )
		}
	},
	setList( items ) {
		const list     = document.querySelector( '.map__wrapper__navigation__list' );
		list.innerHTML = "";

		items.forEach(
			el => {
				this.createListItem( el )
			}
		)
	},
	createListItem( el ) {
		const list = document.querySelector( '.map__wrapper__navigation__list' );

		let div       = document.createElement( 'div' )
		div.className = "map__wrapper__navigation__list__item";

		let divAddress       = document.createElement( 'div' );
		divAddress.className = `map__wrapper__navigation__list__item__address map__wrapper__navigation__list__item__address--${el.category[0]}`

		let spanAddress       = document.createElement( 'span' );
		spanAddress.className = "map__wrapper__navigation__list__item__address__icon";

		let spanAddressIcon = document.createElement( 'span' );
		spanAddress.appendChild( spanAddressIcon );
		divAddress.appendChild( spanAddress );

		let divAddressContent       = document.createElement( 'div' );
		divAddressContent.className = "map__wrapper__navigation__list__item__address__content";

		let pAddress_1       = document.createElement( 'p' );
		pAddress_1.innerText = el.data.address.name;
		divAddressContent.appendChild( pAddress_1 );

		let pAddress_2       = document.createElement( 'p' );

		if( el.category[0] === 'partner' ) {
			pAddress_2.innerText = `${el.data.address.street}`;
		} else {
			pAddress_2.innerText = `${el.data.address.street} ${el.data.address.houseNumber}`;
		}

		divAddressContent.appendChild( pAddress_2 );

		let pAddress_3       = document.createElement( 'p' );
		pAddress_3.innerText = el.data.address.city;
		divAddressContent.appendChild( pAddress_3 );
		divAddress.appendChild( divAddressContent );
		div.appendChild( divAddress );

		if( el.data.openTime.length !== 0 ) {
			let divTime       = document.createElement( 'div' );
			divTime.className = "map__wrapper__navigation__list__item__time";

			let spanTime       = document.createElement( 'span' );
			spanTime.className = "map__wrapper__navigation__list__item__time__icon";

			let spanTimeIcon = document.createElement( 'span' );
			spanTime.appendChild( spanTimeIcon );
			divTime.appendChild( spanTime );

			let pTime       = document.createElement( 'p' );
			pTime.innerText = el.data.openTime;
			divTime.appendChild( pTime );
			div.appendChild( divTime );
		}

		let phoneContainerCreated = false,
			divPhone = null,
			spanPhone = null,
			spanPhoneIcon = null,
			divPhoneWrapper = null,
			pPhone = null

		if( el.category[0] === 'partner' ) {
			el.data.phone.forEach(el => {
				if( el.length !== 0 ) {
					if(!phoneContainerCreated) {
						divPhone       = document.createElement( 'div' );
						divPhone.className = "map__wrapper__navigation__list__item__phone";

						spanPhone       = document.createElement( 'span' );
						spanPhone.className = "map__wrapper__navigation__list__item__phone__icon";

						spanPhoneIcon = document.createElement( 'span' );
						spanPhone.appendChild( spanPhoneIcon );
						divPhone.appendChild( spanPhone );

						divPhoneWrapper       = document.createElement( 'div' );
						divPhoneWrapper.className = "map__wrapper__navigation__list__item__phone__wrapper";

						pPhone       = document.createElement( 'p' );
						pPhone.innerText = el;

						divPhoneWrapper.appendChild( pPhone );
						divPhone.appendChild( divPhoneWrapper );

						phoneContainerCreated = true;
					} else {
						pPhone       = document.createElement( 'p' );
						pPhone.innerText = el;

						divPhoneWrapper.appendChild( pPhone );
						divPhone.appendChild( divPhoneWrapper );
					}
				};

			})

			if( el.data.email && el.data.email.length !== 0  ) {
				let divEmail 		= document.createElement('div');
				divEmail.className = "map__wrapper__navigation__list__item__email";

				let spanEmail       = document.createElement( 'span' );
				spanEmail.className = "map__wrapper__navigation__list__item__email__icon";

				let spanEmailIcon = document.createElement( 'span' );
				spanEmail.appendChild( spanEmailIcon );
				divEmail.appendChild( spanEmail );

				let pEmail       = document.createElement( 'p' );
				pEmail.innerText = el.data.email;
				divEmail.appendChild( pEmail );
				div.appendChild( divEmail );
			}
		} else {
			if( el.data.phone.length > 0 ) {

				divPhone       = document.createElement( 'div' );
				divPhone.className = "map__wrapper__navigation__list__item__phone";

				spanPhone       = document.createElement( 'span' );
				spanPhone.className = "map__wrapper__navigation__list__item__phone__icon";

				spanPhoneIcon = document.createElement( 'span' );
				spanPhone.appendChild( spanPhoneIcon );
				divPhone.appendChild( spanPhone );

				divPhoneWrapper       = document.createElement( 'div' );
				divPhoneWrapper.className = "map__wrapper__navigation__list__item__phone__wrapper";

				pPhone       = document.createElement( 'p' );
				pPhone.innerText = el.data.phone;

				divPhoneWrapper.appendChild( pPhone );
				divPhone.appendChild( divPhoneWrapper );
			};
		}
		divPhone ? div.appendChild( divPhone ) : false;

		let divRoad       = document.createElement( 'div' );
		divRoad.className = "map__wrapper__navigation__list__item__road";
		// make the road element keyboard-accessible
		divRoad.setAttribute('tabindex', '0');
		divRoad.setAttribute('role', 'button');
		divRoad.setAttribute('aria-label', 'Wyznacz trasę');
		divRoad.addEventListener( 'click', () => this.setRoute( el ) )
		divRoad.addEventListener( 'keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				this.setRoute( el );
			}
		});

		let pRoad       = document.createElement( 'p' );
		pRoad.innerText = "Wyznacz trasę";
		divRoad.appendChild( pRoad );
		div.appendChild( divRoad );

		list.appendChild( div );
	},
	setRoute( el ) {
		const index     = el.index
		const latMarker = this.markers[index].position.lat();
		const lngMarker = this.markers[index].position.lng();
		window.open( `https://www.google.com/maps/search/?api=1&query=${latMarker},${lngMarker}`, '_blank' ).focus();
	},
	setNavigationContent( elements ) {
		elements.forEach( el => this.createSpecificItem( el ) )
	},
	createSpecificItem( el ) {
		const specific = document.querySelector( '.map__wrapper__navigation__specific' );

		const divContent = document.createElement( 'div' );
		divContent.classList.add( "map__wrapper__navigation__specific__content" );

		const divAddress     = document.createElement( 'div' );
		divAddress.className = `map__wrapper__navigation__specific__content__address map__wrapper__navigation__specific__content__address--${el.category[0]}`

		const spanAddress     = document.createElement( 'span' );
		spanAddress.className = "map__wrapper__navigation__specific__content__address__icon";

		const spanAddressIcon = document.createElement( 'span' );
		spanAddress.appendChild( spanAddressIcon );
		divAddress.appendChild( spanAddress );

		const divAddressContent     = document.createElement( 'div' );
		divAddressContent.className = "map__wrapper__navigation__specific__content__address__content";

		let pAddress_1       = document.createElement( 'p' );
		pAddress_1.innerText = el.data.address.name;
		divAddressContent.appendChild( pAddress_1 );

		let pAddress_2       = document.createElement( 'p' );
		if( el.category[0] === 'partner' ) {
			pAddress_2.innerText = `${el.data.address.street}`;
		} else {
			pAddress_2.innerText = `${el.data.address.street} ${el.data.address.houseNumber}`;
		}
		divAddressContent.appendChild( pAddress_2 );

		let pAddress_3       = document.createElement( 'p' );
		pAddress_3.innerText = el.data.address.city;
		divAddressContent.appendChild( pAddress_3 );
		divAddress.appendChild( divAddressContent );
		divContent.appendChild( divAddress );

		if( el.data.openTime.length != 0 ) {
			let divTime       = document.createElement( 'div' );
			divTime.className = "map__wrapper__navigation__specific__content__time";

			let spanTime       = document.createElement( 'span' );
			spanTime.className = "map__wrapper__navigation__specific__content__time__icon";

			let spanTimeIcon = document.createElement( 'span' );
			spanTime.appendChild( spanTimeIcon );
			divTime.appendChild( spanTime );

			let pTime       = document.createElement( 'p' );
			pTime.innerText = el.data.openTime;
			divTime.appendChild( pTime );
			divContent.appendChild( divTime );
		}


		let phoneContainerCreated = false,
			divPhone = null,
			spanPhone = null,
			spanPhoneIcon = null,
			divPhoneWrapper = null,
			pPhone = null

		if( el.category[0] === 'partner' ) {
			el.data.phone.forEach(el => {
				if(  el.length > 0 ) {
					if(!phoneContainerCreated) {
						divPhone       = document.createElement( 'div' );
						divPhone.className = "map__wrapper__navigation__specific__content__phone";

						spanPhone       = document.createElement( 'span' );
						spanPhone.className = "map__wrapper__navigation__specific__content__phone__icon";

						spanPhoneIcon = document.createElement( 'span' );
						spanPhone.appendChild( spanPhoneIcon );
						divPhone.appendChild( spanPhone );

						divPhoneWrapper       = document.createElement( 'div' );
						divPhoneWrapper.className = "map__wrapper__navigation__specific__content__phone__wrapper";

						pPhone       = document.createElement( 'p' );
						pPhone.innerText = el;

						divPhoneWrapper.appendChild( pPhone );
						divPhone.appendChild( divPhoneWrapper );

						phoneContainerCreated = true;
					} else {
						pPhone       = document.createElement( 'p' );
						pPhone.innerText = el;

						divPhoneWrapper.appendChild( pPhone );
						divPhone.appendChild( divPhoneWrapper );
					}
				};

			})

			if( el.data.email && el.data.email.length !== 0 ) {
				let divEmail 		= document.createElement('div');
				divEmail.className = "map__wrapper__navigation__specific__content__email";

				let spanEmail       = document.createElement( 'span' );
				spanEmail.className = "map__wrapper__navigation__specific__content__email__icon";

				let spanEmailIcon = document.createElement( 'span' );
				spanEmail.appendChild( spanEmailIcon );
				divEmail.appendChild( spanEmail );

				let pEmail       = document.createElement( 'p' );
				pEmail.innerText = el.data.email;
				divEmail.appendChild( pEmail );

				divContent.appendChild( divEmail );
			}
		} else {
			if( el.data.phone.length > 0 ) {
				divPhone       = document.createElement( 'div' );
				divPhone.className = "map__wrapper__navigation__specific__content__phone";

				spanPhone       = document.createElement( 'span' );
				spanPhone.className = "map__wrapper__navigation__specific__content__phone__icon";

				spanPhoneIcon = document.createElement( 'span' );
				spanPhone.appendChild( spanPhoneIcon );
				divPhone.appendChild( spanPhone );

				divPhoneWrapper       = document.createElement( 'div' );
				divPhoneWrapper.className = "map__wrapper__navigation__specific__content__phone__wrapper";

				pPhone       = document.createElement( 'p' );
				pPhone.innerText = el.data.phone;

				divPhoneWrapper.appendChild( pPhone );
				divPhone.appendChild( divPhoneWrapper );
			};

		}
		divPhone ? divContent.appendChild( divPhone ) : false;

		specific.appendChild( divContent )
	},
	backToList() {
		this.zoomLevel = 12;
		this.map.setZoom( this.zoomLevel );
		this.clickedMarkerIndex = null;
		this.unsetClickedMarkerIcon();

		if (this.isMobile) {
			// Specific to Navigation /Animation
			gsap.timeline(
				{onComplete: () => {
						this.animationElements.specific.classList.remove( 'var_open' );
						this.clickedAnimation = false;
						this.clearSpecificContent();
						// After returning to the list, move focus to the search input for keyboard users
						try {
							if (this.searchInput && typeof this.searchInput.focus === 'function') {
								this.searchInput.focus();
							}
						} catch (e) {
							// non-fatal
						}
					}}
			)
				.to( this.animationElements.specific, {duration: 0.3, opacity: 0,visibility: 'hidden'} )
				.set( this.animationElements.navigator, {clearProps: 'padding'} )
				.to( this.animationElements.navigator, {duration: 0.3, height: 0} )
				.to( this.animationElements.navigator, {duration: 0.3, height: this.animationProperty.navigatorHeight + this.animationProperty.filtersHeight + 'px'} )
				.to( [this.animationElements.filters, this.animationElements.find], {duration: 0.3, opacity: 1, visibility: 'visible', position: 'relative'} )
				.to( this.animationElements.tabs, {duration: 0.3, opacity: 1, visibility: 'visible'} )
				.set( this.animationElements.specific, {clearProps: 'position'} )

		} else {
			// Specific to Navigation /Animation
			gsap.timeline(
				{onComplete: () => {
						this.animationElements.specific.classList.remove( 'var_open' );
						this.clickedAnimation = false;
						this.clearSpecificContent();
						// After returning to the list, move focus to the search input for keyboard users
						try {
							if (this.searchInput && typeof this.searchInput.focus === 'function') {
								this.searchInput.focus();
							}
						} catch (e) {
							// non-fatal
						}
					}}
			)
				.to( [...this.animationElements.specific.children], {duration: 0.3, opacity: 0, visibility: 'hidden'} )
				.to( this.animationElements.specific, {duration: 0.3, height: 0, opacity: 0,visibility: 'hidden'} )
				.to( this.animationElements.navigator, {duration: 0.3, height: 0,visibility: 'hidden'}, '-=0.3' )
				.to( this.animationElements.navigator, {duration: 0.3, visibility: 'visible', height: this.animationProperty.navigatorHeight + this.animationProperty.listHeight + this.animationProperty.filtersHeight + this.animationProperty.listMarginTop + 'px'} )
				.to( [this.animationElements.filters, this.animationElements.list, this.animationElements.find], {duration: 0.3, opacity: 1, visibility: 'visible', position: 'relative'} )
		}
	},
	navigatorBehaviour() {
		if (this.isMobile) {
			if ( ! this.clickedAnimation) {
				if (this.zoomLevel >= 9) {
					// Navigator with find, filters and list /Animation
					gsap.timeline()
						.to( this.animationElements.navigator, {duration: 0.3, height: this.animationProperty.navigatorHeight + this.animationProperty.filtersHeight + 'px'} )
						.to( this.animationElements.filters, {duration: 0.3, opacity: 1, visibility: 'visible', position: 'relative'} )
						.set( this.animationElements.list, {opacity: 0, visibility: 'hidden'}, '-=0.6' )
						.to( this.animationElements.tabs, {duration: 0.3, opacity: 1, visibility: 'visible'}, '-=0.3' )
				} else {
					// Navigator without filters and list /Animation
					gsap.timeline()
						.to( this.animationElements.filters, {duration: 0.3, opacity: 0, visibility: 'hidden'} )
						.to( this.animationElements.navigator, {duration: 0.3, height: this.animationProperty.navigatorHeight + 'px'} )
						.to( this.animationElements.tabs, {duration: 0.3, opacity: 0, visibility: 'hidden'}, '-=0.3' )
				}
			} else {
				if (this.animationElements.specific.classList.contains( 'var_open' )) {
					return;
				}

				gsap.timeline( {onComplete: () => this.animationElements.specific.classList.add( 'var_open' )} )
					.to( [this.animationElements.find, this.animationElements.filters, this.animationElements.list, this.animationElements.tabs], {duration: 0.3, opacity: 0, visibility: "hidden"} )
					.set( [this.animationElements.find, this.animationElements.filters, this.animationElements.list], {position: 'absolute'} )
					.to( this.animationElements.navigator, {duration: 0.3, height: 0, clearProps: 'height'} )
					.set( this.animationElements.navigator, {padding: 0} )
					.fromTo( this.animationElements.specific,{duration: 0.3, height: 0, position: 'relative'} ,{duration: 0.3, opacity: 1, height: 'auto', visibility: "visible"} )
			}
		} else {
			if ( ! this.clickedAnimation) {
				if (this.zoomLevel >= 9) {
					// Navigator with find, filters and list /Animation
					gsap.timeline()
						.to( this.animationElements.navigator, {duration: 0.3, height: this.animationProperty.navigatorHeight + this.animationProperty.listHeight + this.animationProperty.filtersHeight + this.animationProperty.listMarginTop + 'px'} )
						.to( [this.animationElements.filters, this.animationElements.list], {duration: 0.3, opacity: 1, visibility: 'visible', position: 'relative'} )
				} else {
					// Navigator without filters and list /Animation
					gsap.timeline()
						.to( [this.animationElements.filters, this.animationElements.list], {duration: 0.3, opacity: 0, visibility: 'hidden'} )
						.to( this.animationElements.navigator, {duration: 0.3, height: this.animationProperty.navigatorHeight + 'px'} )
				}
			} else {
				if (this.animationElements.specific.classList.contains( 'var_open' )) {
					return;
				}
				// Navigation to Specific place
				gsap.timeline( {onComplete: () => this.animationElements.specific.classList.add( 'var_open' )} )
					.to( [this.animationElements.find, this.animationElements.filters, this.animationElements.list], {duration: 0.3, opacity: 0, visibility: "hidden"} )
					.set( [this.animationElements.find, this.animationElements.filters, this.animationElements.list], {position: 'absolute'} )
					.to( this.animationElements.navigator, {duration: 0.3, height: 0} )
					.set( this.animationElements.navigator, {visibility: 'hidden'} )
					.set( [...this.animationElements.specific.children], {opacity: 0, visibility: 'hidden'} )
					.fromTo( this.animationElements.specific, {duration: 0.3, height: 0}, {duration: 0.3, height: 'auto', opacity: 1, visibility: "visible"} )
					.to( [...this.animationElements.specific.children], {duration: 0.3, opacity: 1, visibility: 'visible'} )
			}
		}
	},
	checkMobileMapDisplay() {
		if ( ! this.isMobile) {
			if (this.mobileNavigatorDisplay == "lista") {
				gsap.timeline()
					.set( this.animationElements.navigator, {clearProps: 'width,position'} )
					.set( this.animationElements.map, {position: 'relative'} )
					.to( this.animationElements.navigator, {duration: 0.3, height: this.animationProperty.navigatorHeight + this.animationProperty.filtersHeight + 'px'} )
					.to( this.animationElements.list, {duration: 0.3, opacity: 0, visibility: 'hidden', position: 'absolute'}, '-=0.3' )
					.to( this.animationElements.map, {duration: 0.3, opacity: 1, visibility: 'visible'}, '-=0.15' )
			}
		}
	},
	handleResize() {
		const paddingTop    = parseFloat( window.getComputedStyle( this.animationElements.navigator ).paddingTop );
		const paddingBottom = parseFloat( window.getComputedStyle( this.animationElements.navigator ).paddingBottom );
		const marginBottom  = parseFloat( window.getComputedStyle( this.animationElements.find ).marginBottom );
		this.animationElements.tabs.classList.remove( 'var_list' );
		this.setFiltersStyle.call( this )

		this.animationProperty = {
			navigatorHeight: this.animationElements.find.offsetHeight + paddingBottom + paddingTop + marginBottom,
			filtersHeight: this.animationElements.filters.offsetHeight,
			listHeight: this.animationElements.list.offsetHeight,
			listMarginTop: parseFloat( window.getComputedStyle( this.animationElements.list ).marginTop ),
			specificHeight: this.animationElements.specific.offsetHeight,
			mapHeight: this.animationElements.map.offsetHeight
		}

		this.isMobile = window.matchMedia( '(max-width: 768px)' ).matches;
		this.checkMobileMapDisplay();
	},
	getEnterPartners() {
		if(!document.body.classList.contains('page-template-page-search-partners')) return;

		let url = `${compensa_general.link}/wp-json/cmp_services/map-points?partners_all=true&address=any`,
			locations = this.settings.locations

		$.get(url,
			(data, status) => {
				let counter = 0;
				data.forEach(
					function (partners) {
						partners.forEach(
							function (el) {
								locations.push(
									[`${counter}`, parseFloat( el.latitude ), parseFloat( el.longitude ), ['partner'], {
										address: {
											name: el.name,
											street: el.street_and_building_number,
											city: el.city
										},
										email: el.email,
										openTime: el.opening_hours,
										phone: [el.phone_1, el.phone_2],
									}]
								);
								counter++;
							}
						)
					}
				)

				this.setClusterMarkers( locations )
				this.observeZoomLevel()
			})
	},
	getLocations( search_value ) {
		let locations = this.settings.locations,
			$this     = this,
			url = (this.settings.mapType !== 'partners') ? `${compensa_general.link}/wp-json/cmp_services/map-points?address=${search_value}&agencies=true&insurance=true&property=true` : `${compensa_general.link}/wp-json/cmp_services/map-points?address=${search_value}&partners=true&lat=${this.settings.searchCoords.lat}&lng=${this.settings.searchCoords.lng}`;
		locations     = [];



		$.get(
			url,
			function (data, status) {
				let counter = 0;
				data.forEach(
					function (el) {
						if (el.partners && el.partners !== 0) {
							el.partners.forEach(
								function (el) {
									locations.push(
										[`${counter}`, parseFloat( el.latitude ), parseFloat( el.longitude ), ['partner'], {
											address: {
												name: el.name,
												street: el.street_and_building_number,
												city: el.city
											},
											openTime: el.opening_hours,
											phone: [el.phone_1, el.phone_2],
											email: el.email,
										}]
									);
									counter++;
								}
							)

						}
						if (el.insurance && el.insurance[0].agents[0].length !== 0) {
							el.insurance[0].agents[0].SearcherInstance.forEach(
								function (el) {
									locations.push(
										[`${counter}`, parseFloat( el.Coordinates.Latitude ), parseFloat( el.Coordinates.Longitude ), ['live','agent'], {
											address: {
												name: el.Name,
												street: el.ContactDetails.Street,
												city: el.ContactDetails.City,
												houseNumber: el.ContactDetails.HouseNo
											},
											openTime: el.OpeningHours,
											phone: el.ContactDetails.PhoneNumber,
										}]
									)
									counter++;
								}
							)

						}
						if (el.property && el.property[0].agents[0].length !== 0) {
							el.property[0].agents[0].SearcherInstance.forEach(
								function (el) {
									locations.push(
										[`${counter}`, parseFloat( el.Coordinates.Latitude ), parseFloat( el.Coordinates.Longitude ), ['property','agent'], {
											address: {
												name: el.Name,
												street: el.ContactDetails.Street,
												city: el.ContactDetails.City,
												houseNumber: el.ContactDetails.HouseNo
											},
											openTime: el.OpeningHours,
											phone: el.ContactDetails.PhoneNumber,
										}]
									)
									counter++;
								}
							)

						}
						if (el.agencies && el.agencies[0] !== 0) {
							el.agencies[0].SearcherInstance.forEach(
								function (el) {
									locations.push(
										[`${counter}`, parseFloat( el.Coordinates.Latitude ), parseFloat( el.Coordinates.Longitude ), ['place'], {
											address: {
												name: el.Name,
												street: el.ContactDetails.Street,
												city: el.ContactDetails.City,
												houseNumber: el.ContactDetails.HouseNo
											},
											openTime: el.OpeningHours,
											phone: el.ContactDetails.PhoneNumber,
										}]
									)
									counter++;
								}
							)

						}

					}
				)
				if ($this.markerClusterer) {
					$this.markerClusterer.clearMarkers()
				}
				$this.setClusterMarkers( locations )

				$this.observeZoomLevel()
			}
		)
	}
}

export default googleMaps;

window.addEventListener('load', () => googleMaps.init())
